import _ from 'lodash'
import promotionApi from '@/api/promotiom'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    promotionApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  delete({ commit }, id) {
    return promotionApi.delete(id)
      .then(() => commit('PROMOTION_REMOVED', id))
      .catch(error => {
        commit('PROMOTION_REMOVE_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  PROMOTION_REMOVED(state, id) {
    store.dispatch('promotion/fetchList')
    store.dispatch('message/success', 'PROMOTION.success')
  },
  PROMOTION_REMOVE_FAILED(state, { id, errors }) {
    store.dispatch('message/error', 'PROMOTION.removeFailure')
    state.errors = errors
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.promotion.filters, _.debounce(async () => await store.dispatch('promotion/fetchList'), 250), { immediate: false, deep: true }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
